import React from "react";
function TermItem(props) {
  return (
    <RenderHTML text={props.text}></RenderHTML>
  );
}
export default TermItem;

const RenderHTML = (props) => (
  <div className="list-group-item d-flex justify-content-start align-items-left" dangerouslySetInnerHTML={{ __html: props.text }}></div>
)